import React from "react";
import Skeleton from "react-loading-skeleton";
import { getRandomNumber } from "../../utils/helper";
import StyledTableSkeleton from "../../components/StyledComponents/StyledTableSkeleton";

const HomePageSkeleton = ({ index }) => {
  return (
    <>
      <div className="p-md-3 __card-header d-flex align-items-center mb-5 mb-md-0">
        <span className={"d-none d-md-block ms-md-3"}>
          <Skeleton width={80} height={80} circle />
        </span>

        <span className="bg-transparent rounded-circle d-block d-md-none ms-md-3">
          <Skeleton
            width={85}
            height={85}
            className={"d-block d-md-none"}
            circle
          />
        </span>

        <div className="d-none d-md-flex flex-column ps-4 gap-1">
          <Skeleton width={100} height={16} />
          <Skeleton width={150} height={12} />
        </div>
      </div>
      <div className="__card-body">
        <div className="__card-body-inner p-4 p-md-4 m-0 m-lg-2 d-flex flex-column gap-2 gap-md-3">
          <Skeleton width={150} height={22} />
          <div className="__edit-personal-info">
            {Array.from({ length: 3 }, (_, index) => (
              <div
                key={index}
                className="d-flex align-items-center mt-2 mb-3 my-md-4"
              >
                <Skeleton width={20} height={20} />
                <div className="d-flex justify-content-between w-100 align-items-center ms-3">
                  <Skeleton width={getRandomNumber(100, 250)} height={16} />
                  <Skeleton width={20} height={20} />
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="__card-body-inner p-4 py-md-4 pt-md-0  m-0 m-lg-2">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <Skeleton width={150} height={22} />

            <div className="d-none d-md-block">
              <Skeleton width={150} height={40} />
            </div>

            <div className="d-flex d-md-none align-self-end">
              <Skeleton width={30} height={30} />
            </div>
          </div>
          <StyledTableSkeleton />
        </div>
      </div>
    </>
  );
};
export default HomePageSkeleton;
